import { Alert, AlertProps, AlertTitle, Typography, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { Project, User } from '../types'

export interface UserAppNotificationsDisabledWarningAlertProps
  extends Omit<AlertProps, 'children' | 'severity'> {
  user: User
  project?: Project | null
}

export default function UserAppNotificationsWarningAlert({
  user,
  project,
  ...props
}: UserAppNotificationsDisabledWarningAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  /**
   * Indicates if the current user has app notifications enabled.
   */
  const appNotificationsEnabled =
    user.notificationsInApp &&
    (project === undefined ||
      project === null ||
      Boolean(user?.projects?.find((p) => p.projectId === project?.id)?.showInAppNotifications))

  return (
    <>
      {!appNotificationsEnabled && (
        <Alert severity="warning" {...props}>
          <AlertTitle>{t('appNotificationsDisabled')}</AlertTitle>
          <Typography>{t('appNotificationsDisabledWarning')}</Typography>
          <Button
            component={NavLink}
            to={`/users/${user.id}#notifications`}
            variant="outlined"
            color="warning"
            size="small"
            sx={{ mt: 2 }}
          >
            {t('goToNotificationSettings')}
          </Button>
        </Alert>
      )}
    </>
  )
}
